module.exports = __webpack_public_path__ + "r-v3/img/mic_on.9cfc953c.svg";